import { useSearch } from '@tanstack/react-router'

import { Alert, AlertDescription, AlertTitle } from '@/components/alert'

const WelcomeBanner = () => {
    const x = useSearch({
        from: '/_authed/$client_code/',
    })
    if (!x.welcome) {
        return null
    }
    return (
        <Alert variant="success">
            <AlertTitle>Welcome!</AlertTitle>
            <AlertDescription>It's great to have you here 🎉</AlertDescription>
        </Alert>
    )
}

export default WelcomeBanner
